import { memo } from "react";
import { Typography } from "@libs/zapi-ui/custom";
import { cn } from "@/zapi-frontend/shared/lib/utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "@libs/zapi-ui/shadcn";
import { SidebarDashboardIcon } from "./_SidebarDashboardIcon";

type SidebarDashboardItemProps = {
  isActive: boolean;
  handleDashboardClick: () => void;
  isSidebarOpen: boolean;
  isLoading: boolean;
  isProjectOverviewMode: boolean;
};

export const SidebarDashboardItem = memo((props: SidebarDashboardItemProps) => {
  const { isActive, handleDashboardClick, isSidebarOpen, isLoading, isProjectOverviewMode } = props;

  const title = isProjectOverviewMode ? "Project Overview" : "Dashboard";

  return (
    <Tooltip open={!isSidebarOpen ? undefined : false}>
      <TooltipTrigger asChild>
        <div data-testid="sidebar-dashboard" className="w-full flex flex-col items-center justify-center">
          <div
            className={cn("w-full flex justify-start items-center cursor-pointer group")}
            onClick={handleDashboardClick}
            data-testid="sidebar-dashboard-header"
          >
            <SidebarDashboardIcon isActive={isActive} isLoading={isLoading} />

            <Typography
              variant="label2"
              color={isActive ? "zinc900" : "zinc500"}
              className={cn(
                "font-medium max-w-[200px] truncate ml-2 transition-colors duration-300 group-hover:text-innoveraZinc-900"
              )}
              style={{ lineHeight: "120%" }}
              data-testid="sidebar-dashboard-title"
            >
              {title}
            </Typography>
          </div>
        </div>
      </TooltipTrigger>
      <TooltipContent side="right">
        <Typography variant="body3">{title}</Typography>
      </TooltipContent>
    </Tooltip>
  );
});
SidebarDashboardItem.displayName = "SidebarDashboardItem";
